<template>
  <div class="text-center" v-if="this.params.data.status == '0'">
    <feather-icon icon="CheckIcon" :title="$t('adminPackage.textAgree')" style="color: #0072ff" svgClasses="h-8 w-7 mr-5 mt-3" @click="processRequest"/>
    <feather-icon icon="XIcon" :title="$t('adminPackage.textRefuse')" style="color: red" svgClasses="h-8 w-7 mr-5 mt-3" @click="rejectedRequest"/>
  </div>
</template>

<script>
  const accepted = 1;
  const rejected = 2;
  export default {
    name: 'CellRendererPackageActions',
    methods: {
      processRequest() {
        this.$router.push(`/admin/package/approve?id=${this.params.data.id}`).catch(() => {
        });
        // let conditions = {
        //   "packageId": this.params.data.businessPackage.id,
        //   "status": accepted
        // }
        // this.$vs.loading();
        // this.$business.post(`/user-package/process/${this.params.data.id}`, conditions).then(() => {
        //   this.$vs.loading.close();
        //   return this.showProcessSuccess();
        // }).catch((err) => {
        //   this.$vs.loading.close();
        //   return this.$vs.notify({
        //     text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //     iconPack: 'feather',
        //     icon: 'icon-alert-circle',
        //     color: 'danger'
        //   });
        // });
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('adminPackage.confirmCancel'),
          text: `${this.$t('adminUser.textDl')} ` + `"${this.params.data.fullName.businessPackage.name}"` + `?`,
          accept: this.deleteRecord,
          acceptText: this.$t('adminPackage.acceptTextUpgrade'),
          cancelText: this.$t('adminPackage.cancelText')
        })
      },
      rejectedRequest() {
        let conditions = {
          "packageId": this.params.data.businessPackage.id,
          "status": rejected
        }
        this.$vs.loading();
        this.$business.post(`/user-package/process/${this.params.data.id}`, conditions).then(() => {
          this.$vs.loading.close();
          return this.showDeleteSuccess();
        }).catch((err) => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      },
      showProcessSuccess() {
        this.$store.commit('UPDATE_ADMIN_REQUEST_PACKAGE', true);
        this.$vs.notify({
          color: 'primary',
          text:  this.$t('adminPackage.textSuccessUpgrade'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        })
      },
      showDeleteSuccess() {
        this.$store.commit('UPDATE_ADMIN_REQUEST_PACKAGE', true);
        this.$vs.notify({
          color: 'primary',
          text: this.$t('adminPackage.textRefuseUpgrade'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        })
      }
    }
  }
</script>
